export class SystemList {
    constructor(initialListData) {
        // Initialize properties from initialListData
        this.tableName = initialListData.tableName;
        this.tableDisplayName = initialListData.displayTableName;
        this.fields = initialListData.fields;
    }

    // Getter for tableName
    getTableName() {
        return this.tableName;
    }

    // Getter for displayTableName
    getTableDisplayName() {
        return this.tableDisplayName;
    }

    // Getter for fields
    getFields() {
        return this.fields;
    }

    // Getter for checked rows in the current list
    getChecked() {
        const checkedIds = [];
        $('.row-checkbox:checked').each(function() {
            checkedIds.push($(this).data('sysid'));
        });
        return checkedIds;
    }
}
